import { actionCreatorFactory } from '../../core/utils/factories';
import {
  JurisdictionBrowse,
  JurisdictionDetailsContacts,
  JurisdictionDetailsPermitting,
  JurisdictionDetailsZoning,
  JurisdictionModalValues,
  JurisdictionPermittingData,
  JurisdictionSummaryZoning,
  JurisdictionZoningData,
  PaginatedResponse,
} from '../../models/interfaces';

const actionCreator = actionCreatorFactory('JURISDICTION');

export namespace JurisdictionActions {
  export const setTabLoading = actionCreator.createAsyncAction<{
    tabName: string;
    isLoading: boolean;
  }>('SET_TAB_LOADING');

  export const resetTabsData =
    actionCreator.createAsyncAction('RESET_TABS_DATA');

  export const getJurisdictionBrowseData = actionCreator.createAsyncAction<
    PaginatedResponse<JurisdictionBrowse>
  >('GET_JURISDICTION_BROWSE_DATA');

  export const addJurisdiction =
    actionCreator.createAsyncAction<PaginatedResponse<JurisdictionBrowse>>(
      'ADD_JURISDICTION',
    );

  // JURISDICTION - ZONING
  export const getJurisdictionZoning =
    actionCreator.createAsyncAction<JurisdictionSummaryZoning>(
      'GET_JURISDICTION_ZONING',
    );

  export const addJurisdictionZoningPanel =
    actionCreator.createAsyncAction<JurisdictionDetailsZoning>(
      'ADD_JURISDICTION_ZONING_PANEL',
    );

  export const updateJurisdictionZoning =
    actionCreator.createAsyncAction<JurisdictionZoningData>(
      'UPDATE_JURISDICTION_ZONING',
    );

  export const updateJurisdictionZoningPanel =
    actionCreator.createAsyncAction<JurisdictionModalValues>(
      'UPDATE_JURISDICTION_ZONING_PANEL',
    );

  export const removeJurisdictionZoningPanel =
    actionCreator.createAsyncAction<string>('REMOVE_JURISDICTION_ZONING_PANEL');

  // JURISDICTION - PERMITTING
  export const getJurisdictionPermitting = actionCreator.createAsyncAction<
    JurisdictionDetailsPermitting[]
  >('GET_JURISDICTION_PERMITTING');

  export const addJurisdictionPermittingPanel =
    actionCreator.createAsyncAction<JurisdictionDetailsPermitting>(
      'ADD_JURISDICTION_PERMITTING_PANEL',
    );

  export const updateJurisdictionPermittingPanel =
    actionCreator.createAsyncAction<JurisdictionModalValues>(
      'UPDATE_JURISDICTION_PERMITTING_PANEL',
    );

  export const updateJurisdictionPermitting =
    actionCreator.createAsyncAction<JurisdictionPermittingData>(
      'UPDATE_JURISDICTION_PERMITTING',
    );

  export const removeJurisdictionPermittingPanel =
    actionCreator.createAsyncAction<string>(
      'REMOVE_JURISDICTION_PERMITTING_PANEL',
    );

  // JURISDICTION - CONTACTS
  export const getJurisdictionContacts = actionCreator.createAsyncAction<
    JurisdictionDetailsContacts[]
  >('GET_JURISDICTION_CONTACTS');

  export const addJurisdictionContact =
    actionCreator.createAsyncAction<JurisdictionDetailsContacts>(
      'ADD_JURISDICTION_CONTACT',
    );

  export const updateJurisdictionContact =
    actionCreator.createAsyncAction<JurisdictionDetailsContacts>(
      'UPDATE_JURISDICTION_CONTACT',
    );

  export const removeJurisdictionContact =
    actionCreator.createAsyncAction<string>('REMOVE_JURISDICTION_CONTACT');
}
